<template>
  <div class="navbar-header">
<!--    <a id="mobile_btn" href="javascript:void(0);">-->
<!--        <span class="bar-icon">-->
<!--            <span></span>-->
<!--            <span></span>-->
<!--            <span></span>-->
<!--        </span>-->
<!--    </a>-->
    <div class="navbar-brand logo">
      <div class="img-fluid bg-logo" style="width: 182px; height: 46px; "/>
    </div>

    <HeaderNotificacoesMobile />
    <mainnav></mainnav>

  </div>
</template>
<script>
import Helper from "../../src/helpers/helper.service";
import HeaderNotificacoesMobile from './HeaderNotificacoesMobile.vue'

export default {
  name: "Navbar",
  components: { HeaderNotificacoesMobile },
  computed: {
    getTheme() {
      return Helper.getTheme()
    }
  },
}
</script>

<style scoped>
@media (max-width: 991.98px) {
  .navbar-header {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .navbar-header :deep(.header-notificacoes-mobile) {
    margin-left: auto;
  }

  .navbar-header :deep(#btnMenu) {
    float: none;
  }
}
</style>
